import React from "react";
import useAuthenticatedImage from "../../hooks/useAuthenticatedImage";

export default function NotificationImage({ noticeId }) {
  const blobUrl = useAuthenticatedImage(`/User/NoticeImage/${noticeId}`);

  if (!blobUrl) return null;

  return (
    <img
      className="notification-image"
      alt=""
      src={blobUrl}
    />
  );
}
